import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Quote, ChevronLeft, ChevronRight } from 'lucide-react';
const testimonials = [{
  quote: 'Antes solo publicaba fotos de platos en Instagram. Ahora con el menú digital, los clientes llegan informados y listos para reservar.',
  author: 'Chef Marco Solano',
  role: 'Restaurante La Brasa Dorada',
  image: 'https://images.unsplash.com/photo-1583394838336-acd977736f90?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  quote: 'En la primera semana con el menú digital + Meta Ads conseguí 25 reservaciones nuevas. Nunca había llenado las mesas tan rápido.',
  author: 'María Fernanda López',
  role: 'Café & Bistro Aroma',
  image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  quote: 'La inversión se pagó con las primeras 5 mesas. Mi menú digital muestra los platos y el ambiente de forma profesional.',
  author: 'Roberto Quesada',
  role: 'Marisquería El Puerto',
  image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  quote: 'Tenía mi restaurante solo en Facebook y perdía muchos clientes. Ahora la gente ve el menú completo y reserva directo.',
  author: 'Ana Lucía Mora',
  role: 'Sushi House CR',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}, {
  quote: 'El equipo A-Z entendió perfecto mi concepto gastronómico. El menú digital transmite exactamente la experiencia que ofrecemos.',
  author: 'Diego Herrera',
  role: 'Trattoria Bella Vita',
  image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=crop&w=200&q=80'
}];
export function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex(prev => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);
  const next = () => setCurrentIndex(prev => (prev + 1) % testimonials.length);
  const prev = () => setCurrentIndex(prev => (prev - 1 + testimonials.length) % testimonials.length);
  return <section id="testimonios" className="py-24 bg-[#0a0a1a] relative overflow-hidden" data-id="element-489">
      {/* Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-490">
        <div className="absolute top-1/2 left-1/4 w-96 h-96 bg-purple-900/10 rounded-full blur-[100px]" data-id="element-491" />
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-blue-900/10 rounded-full blur-[80px]" data-id="element-492" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-493">
        <div className="text-center mb-16" data-id="element-494">
          <h2 className="text-3xl md:text-5xl font-bold font-orbitron mb-4" data-id="element-495">
            Restaurantes Que Ya{' '}
            <span className="text-gradient-cosmic" data-id="element-496">Están Creciendo</span>
          </h2>
        </div>

        <div className="relative bg-[#050510]/50 backdrop-blur-xl border border-white/5 rounded-3xl p-8 md:p-12 shadow-2xl" data-id="element-497">
          <Quote className="absolute top-8 left-8 w-12 h-12 text-purple-500/20" data-id="element-498" />

          <div className="min-h-[250px] flex items-center justify-center" data-id="element-499">
            <AnimatePresence mode="wait" data-id="element-500">
              <motion.div key={currentIndex} initial={{
              opacity: 0,
              x: 20
            }} animate={{
              opacity: 1,
              x: 0
            }} exit={{
              opacity: 0,
              x: -20
            }} transition={{
              duration: 0.4
            }} className="text-center" data-id="element-501">
                <p className="text-xl md:text-3xl font-medium text-white mb-8 leading-relaxed italic" data-id="element-502">
                  "{testimonials[currentIndex].quote}"
                </p>
                <div className="flex flex-col items-center gap-4" data-id="element-503">
                  <div className="w-16 h-16 rounded-full p-1 bg-gradient-to-r from-purple-500 to-pink-500" data-id="element-504">
                    <img src={testimonials[currentIndex].image} alt={testimonials[currentIndex].author} className="w-full h-full rounded-full object-cover border-2 border-[#050510]" data-id="element-505" />
                  </div>
                  <div data-id="element-506">
                    <h4 className="text-lg font-bold text-white font-orbitron" data-id="element-507">
                      {testimonials[currentIndex].author}
                    </h4>
                    <p className="text-purple-400" data-id="element-508">
                      {testimonials[currentIndex].role}
                    </p>
                  </div>
                </div>
              </motion.div>
            </AnimatePresence>
          </div>

          {/* Controls */}
          <div className="flex justify-center gap-4 mt-8" data-id="element-509">
            <button onClick={prev} className="p-2 rounded-full bg-white/5 hover:bg-white/10 text-white transition-colors" aria-label="Previous testimonial" data-id="element-510">
              <ChevronLeft className="w-6 h-6" data-id="element-511" />
            </button>
            <div className="flex gap-2 items-center" data-id="element-512">
              {testimonials.map((_, idx) => <button key={idx} onClick={() => setCurrentIndex(idx)} className={`w-2.5 h-2.5 rounded-full transition-all duration-300 ${idx === currentIndex ? 'bg-purple-500 w-6' : 'bg-gray-600'}`} aria-label={`Go to testimonial ${idx + 1}`} data-id="element-513" />)}
            </div>
            <button onClick={next} className="p-2 rounded-full bg-white/5 hover:bg-white/10 text-white transition-colors" aria-label="Next testimonial" data-id="element-514">
              <ChevronRight className="w-6 h-6" data-id="element-515" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}